
/**
 * Fonction pour obtenir les programmes immobiliers avec les traductions
 * @param {Function} t - Fonction de traduction i18next
 * @returns {Array} Liste des programmes immobiliers
 */
export const getRealEstatePrograms = (t) => [
  // Balena
  {
    id: 1,
    projectKey: 'balena',
    propertyTypeKey: 'villa',
    locationKey: 'almadies',
    title: t('projects.balena.title'),
    type: t('projects.balena.type'),
    description: t('projects.balena.description'),
    price: t('projects.balena.price'),
    image: "/images/projects/balena1.jpg",
    gallery: [
      "/images/projects/balena1.jpg",
      "/images/projects/balena2.jpg",
      "/images/projects/balena3.jpg",
      "/images/projects/balena4.png",
      "/images/projects/balena5.png",
      "/images/projects/balena6.png",
      "/images/projects/balena7.png",
      "/images/projects/balena8.png",
      "/images/projects/balena9.png",
      "/images/projects/balena10.png",
      "/images/projects/balena11.png",
      "/images/projects/balena12.png",
      "/images/projects/balena13.png",
      "/images/projects/balena14.png",
      "/images/projects/balena15.png", 
    ],
    details: {
      surface: t('projects.balena.type').split('–')[1]?.trim() || t('projects.balena.type'),
      chambres: 5,
      sdb: 6,
      parking: 1,
      etage: t('projects.balena.floor'),
      piscine: 1
    },
    caracteristiques: t('projects.balena.features', { returnObjects: true }),
    localisation: {
      adresse: t('projects.balena.address'),
      localisation: t('projects.balena.localisation'),
      mapUrl: "https://www.google.com/maps/place/14%C2%B044'40.2%22N+17%C2%B030'18.5%22W/@14.7445033,-17.505137,17z/data=!3m1!4b1!4m4!3m3!8m2!3d14.7445033!4d-17.505137?entry=ttu"
    },
  },
  // Sirena
  {
    id: 2,
    projectKey: 'sirena',
    propertyTypeKey: 'appartement',
    locationKey: 'almadies',
    title: t('projects.sirena.title'),
    type: t('projects.sirena.type'),
    description: t('projects.sirena.description'),
    price: t('projects.sirena.price'),
    image: "/images/projects/sirena1.png",
    gallery: [
      "/images/projects/sirena1.png",
      "/images/projects/sirena2.png",
      "/images/projects/sirena3.png",
      "/images/projects/sirena4.png",
      "/images/projects/sirena5.png",
      "/images/projects/sirena6.png",
      "/images/projects/sirena7.png",
      "/images/projects/sirena8.png",
      "/images/projects/sirena9.png"
    ],
    details: {
      surface: t('projects.sirena.type').split('–')[1]?.trim() || t('projects.sirena.type'),
      chambres: 4,
      sdb: 5,
      parking: 1,
      etage: 'R+1',
      duree: t('projects.sirena.duration')
    },
    caracteristiques: t('projects.sirena.features', { returnObjects: true }),
    localisation: {
      adresse: t('projects.sirena.address'),
      localisation: t('projects.sirena.localisation'),
      mapUrl: "https://www.google.com/maps/place/14%C2%B044'40.2%22N+17%C2%B030'18.5%22W/@14.7445033,-17.505137,17z/data=!3m1!4b1!4m4!3m3!8m2!3d14.7445033!4d-17.505137?entry=ttu"
    },
  },
  // Parcelles viabilisées – Almadies
  {
    id: 3,
    projectKey: 'almadies',
    propertyTypeKey: 'parcelles',
    locationKey: 'almadies',
    title: t('projects.almadies.title'),
    type: t('projects.almadies.type'),
    description: t('projects.almadies.description'),
    price: t('projects.almadies.price'),
    image: "/images/projects/viabilises.jpg",
    details: {
      surface: t('projects.almadies.type').split('–')[1]?.trim() || t('projects.almadies.type'),
      naturePapier: t('projects.almadies.naturePapier'),
      statut: t('projects.almadies.statut')
    },
    caracteristiques: t('projects.almadies.features', { returnObjects: true }),
    localisation: {
      adresse: t('projects.almadies.address'),
      localisation: t('projects.almadies.localisation'),
      mapUrl: "https://www.google.com/maps/place/14%C2%B044'40.2%22N+17%C2%B030'18.5%22W/@14.7445033,-17.505137,17z/data=!3m1!4b1!4m4!3m3!8m2!3d14.7445033!4d-17.505137?entry=ttu"
    },
  },
  // Tivaouane Peulh
  {
    id: 4,
    projectKey: 'tivaouane',
    propertyTypeKey: 'logements_sociaux',
    locationKey: 'tivaouanePeulh',
    title: t('projects.tivaouane.title'),
    type: t('projects.tivaouane.type'),
    description: t('projects.tivaouane.description'),
    price: t('projects.tivaouane.price'),
    image: "/images/projects/lac1.jpg",
    gallery: [
      "/images/projects/lac1.jpg",
      "/images/projects/lac2.jpg",
      "/images/projects/tivaoune_peulh.jpg",
    ],
    details: {
      surface: t('projects.tivaouane.type').split('–')[1]?.trim() || t('projects.tivaouane.type'),
      chambres: 2,
      sdb: 2,
      parking: 1,
      etage: t('projects.tivaouane.floor'),
      annee: 2023
    },
    caracteristiques: [],
    localisation: {
      adresse: t('projects.tivaouane.address'),
      localisation: t('projects.tivaouane.localisation'),
      mapUrl: ''
    },
  },
  // ndiakhirate F3
  {
    id: 5,
    projectKey: 'ndiakhirate',
    propertyTypeKey: 'villa',
    locationKey: 'ndiakhirate',
    title: t('projects.ndiakhirate.titleF3'),
    type: t('projects.ndiakhirate.type'),
    description: t('projects.ndiakhirate.description'),
    price: "35 000 000 FCFA",
    image: "/images/projects/ndiakhirate1.jpg",
    gallery: [
      "/images/projects/ndiakhirate1.jpg",
      "/images/projects/ndiakhirate2.jpg",
      "/images/projects/ndiakhirate3.jpg",
      "/images/projects/ndiakhirate4.jpg",
      "/images/projects/ndiakhirate5.jpg",
      "/images/projects/ndiakhirate6.jpg"
    ],
    details: {
      surface: "150 m²",
      chambres: 2,
      sdb: 2,
      parking: 1,
      etage: t('projects.ndiakhirate.floor')
    },
    caracteristiques: t('projects.ndiakhirate.features', { returnObjects: true }),
    localisation: {
      adresse: t('projects.ndiakhirate.address'),
      localisation: t('projects.ndiakhirate.localisation'),
      mapUrl: ''
    },
  },
  // ndiakhirate F4
  {
    id: 6,
    projectKey: 'ndiakhirate',
    propertyTypeKey: 'villa',
    locationKey: 'ndiakhirate',
    title: t('projects.ndiakhirate.titleF4'),
    type: t('projects.ndiakhirate.type'),
    description: t('projects.ndiakhirate.description'),
    price: "55 000 000 FCFA",
    image: "/images/projects/ndiakhirate1.jpg",
    gallery: [
      "/images/projects/ndiakhirate1.jpg",
      "/images/projects/ndiakhirate2.jpg",
      "/images/projects/ndiakhirate3.jpg",
      "/images/projects/ndiakhirate4.jpg",
      "/images/projects/ndiakhirate5.jpg",
      "/images/projects/ndiakhirate6.jpg"
    ],
    details: {
      surface: "150 m²",
      chambres: 3,
      sdb: 3,
      parking: 1,
      etage: t('projects.ndiakhirate.floor')
    },
    caracteristiques: t('projects.ndiakhirate.features', { returnObjects: true }),
    localisation: {
      adresse: t('projects.ndiakhirate.address'),
      localisation: t('projects.ndiakhirate.localisation'),
      mapUrl: ''
    },
  },
  // ndiakhirate R+1 type F4
  {
    id: 7,
    projectKey: 'ndiakhirate',
    propertyTypeKey: 'villa',
    locationKey: 'ndiakhirate',
    title: t('projects.ndiakhirate.titleR1'),
    type: t('projects.ndiakhirate.type'),
    description: t('projects.ndiakhirate.description'),
    price: "78 000 000 FCFA",
    image: "/images/projects/ndiakhirate7.jpeg",
    gallery: [
      "/images/projects/ndiakhirate7.jpeg",
      "/images/projects/ndiakhirate8.jpeg",
      "/images/projects/ndiakhirate9.jpeg",
      "/images/projects/ndiakhirate10.jpeg",
      "/images/projects/ndiakhirate11.jpeg"
    ],
    details: {
      surface: "150 m²",
      chambres: 5,
      sdb: 4,
      parking: 1,
      etage: "R+1"
    },
    caracteristiques: t('projects.ndiakhirate.features', { returnObjects: true }),
    localisation: {
      adresse: t('projects.ndiakhirate.address'),
      localisation: t('projects.ndiakhirate.localisation'),
      mapUrl: ''
    },
  },
  // Almadies 2 Terrains
  {
    id: 8,
    projectKey: 'almadies2',
    propertyTypeKey: 'parcelles',
    locationKey: 'almadies2',
    title: t('projects.almadies2.title'),
    type: t('projects.almadies2.type'),
    description: t('projects.almadies2.description'),
    price: t('projects.almadies2.price'),
    image: "/images/projects/viabilises.jpg",
    gallery: [],
    details: {
      surface: t('projects.almadies2.type').split('–')[1]?.trim() || t('projects.almadies2.type'),
      naturePapier: t('projects.almadies2.naturePapier'),
      statut: t('projects.almadies2.statut')
    },
    caracteristiques: t('projects.almadies.features', { returnObjects: true }),
    localisation: {
      adresse: t('projects.almadies2.address'),
      localisation: t('projects.almadies2.localisation'),
      mapUrl: "https://www.google.com/maps/place/14%C2%B044'40.2%22N+17%C2%B030'18.5%22W/@14.7445033,-17.505137,17z/data=!3m1!4b1!4m4!3m3!8m2!3d14.7445033!4d-17.505137?entry=ttu"
    },
  },
  // HLM
  {
    id: 9,
    projectKey: 'hlm',
    propertyTypeKey: 'Boutiques',
    locationKey: 'hlm5',
    title: t('projects.hlm.title'),
    type: t('projects.hlm.type'),
    description: t('projects.hlm.description'),
    price: t('projects.hlm.price'),
    image: "/images/projects/hlm.jpg",
    details: {
      surface: t('projects.hlm.type').split('–')[1]?.trim() || t('projects.hlm.type'),
      chambres: 0,
      sdb: 1,
      parking: 0,
      etage: t('projects.hlm.floor'),
      annee: 2024
    },
    caracteristiques: t('projects.hlm.features', { returnObjects: true }),
    localisation: {
      adresse: t('projects.hlm.address'),
      localisation: t('projects.hlm.localisation'),
      mapUrl: "https://www.google.com/maps/place/14%C2%B042'19.0%22N+17%C2%B026'42.5%22W/@14.7052781,-17.445137,17z/data=!3m1!4b1!4m4!3m3!8m2!3d14.7052781!4d-17.445137?entry=ttu"
    },
  }
];

/**
 * Fonction pour adapter les données des programmes immobiliers au format attendu par ProjectCard
 * @param {Object} program - Programme immobilier
 * @param {Function} t - Fonction de traduction i18next
 * @returns {Object} Données formatées pour ProjectCard
 */
export const formatProjectCardData = (program, t) => ({
  id: program.id,
  title: program.title,
  location: program.localisation?.localisation || '',
  type: program.type,
  area: program.details?.surface || '',
  image: program.image,
  price: program.price,
  chambres: program.details?.chambres || 0,
  sdb: program.details?.sdb || 0,
  description: program.description,
  details: t('projects.viewDetails'),
  contact: t('projects.contactUs')
});
